<template>
  <h2>Popular destinations</h2>
  <popular-searches-glamping
    class="horizontal-slider"
    :popular-searches="POPULAR_DESTINATIONS"
  />
</template>

<script setup lang="ts">
// https://www.lichter.io/articles/nuxt3-vue3-dynamic-images/#the-importmetaglob-trick
const glob = import.meta.glob('@/assets/popular-searches/*.jpg', {
  query: '?url',
  eager: true,
})
const POPULAR_DESTINATIONS = [
  {
    name: 'Scotland',
    url: '/glamping/Scotland/',
    imgUrl: glob['/assets/popular-searches/scotland.jpg'].default,
  },
  {
    name: 'Wales',
    url: '/glamping/Wales/',
    imgUrl: glob['/assets/popular-searches/wales.jpg'].default,
  },
  {
    name: 'Cornwall',
    url: '/glamping/England/South_West/Cornwall/',
    imgUrl: glob['/assets/popular-searches/cornwall.jpg'].default,
  },
  {
    name: 'Norfolk',
    url: '/glamping/England/East_Anglia/Norfolk/',
    imgUrl: glob['/assets/popular-searches/norfolk.jpg'].default,
  },
  {
    name: 'New Forest',
    url: '/glamping/England/South_East/Hampshire/Fritham/',
    imgUrl: glob['/assets/popular-searches/new-forest.jpg'].default,
  },
  {
    name: 'Devon',
    url: '/glamping/England/South_West/Devon/',
    imgUrl: glob['/assets/popular-searches/devon.jpg'].default,
  },
  {
    name: 'Northumberland',
    url: '/glamping/England/North_East/Northumberland/',
    imgUrl: glob['/assets/popular-searches/northumberland.jpg'].default,
  },
  {
    name: 'The Lake District and Cumbria',
    url: '/glamping/England/North_West/Cumbria/',
    imgUrl: glob['/assets/popular-searches/lake-district.jpg'].default,
  },
  {
    name: 'North Yorkshire',
    url: '/glamping/England/North_East/North_Yorkshire/',
    imgUrl: glob['/assets/popular-searches/north-yorkshire.jpg'].default,
  },
  {
    name: 'Northern Ireland',
    url: '/glamping/Northern_Ireland/',
    imgUrl: glob['/assets/popular-searches/northern-ireland.jpg'].default,
  },
  {
    name: 'The Peak District',
    url: '/glamping/England/Central/Derbyshire/tideswell/',
    imgUrl: glob['/assets/popular-searches/peak-district.jpg'].default,
  },
].map((d) => {
  return {
    ...d,
    to: {
      hierarchyPath: d.url.replace('/glamping/', ''),
      category: 'glamping',
    },
    label: d.name,
    imgUrl: d.imgUrl
      ? d.imgUrl
      : glob['/assets/popular-searches/lake-district.jpg'].default,
    isLCP: false,
    displayOrder: d.displayOrder || 0,
  }
})
</script>
